import { Controller } from "stimulus";
import OpSelect from "~/scripts/components/OpSelect";

export default class extends Controller {
    opened = false;

    static targets = ["dropdown", "select", "section"];

    initialize() {
        this.scrollTo = this.scrollTo.bind(this);
    }

    connect() {
        this.opSelect = new OpSelect({
            el: this.dropdownTarget,
            textClass: "dropdown__text",
            textInnerClass: "dropdown__text-inner",
            select: this.selectTarget,
            onChangeCallback: this.scrollTo
        });
    }

    calculateScrollOffset(elem, additionalOffset, alignment) {
        const body = document.body,
            html = document.documentElement;

        const elemRect = elem.getBoundingClientRect();
        const clientHeight = html.clientHeight;
        const documentHeight = Math.max(
            body.scrollHeight,
            body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
        );

        additionalOffset = additionalOffset || 0;

        let scrollPosition;
        if (alignment === "bottom") {
            scrollPosition = elemRect.bottom - clientHeight;
        } else if (alignment === "middle") {
            scrollPosition =
                elemRect.bottom - clientHeight / 2 - elemRect.height / 2;
        } else {
            // top and default
            scrollPosition = elemRect.top;
        }

        const maxScrollPosition = documentHeight - clientHeight;
        return Math.min(
            scrollPosition + additionalOffset + window.pageYOffset,
            maxScrollPosition
        );
    }

    scrollTo() {
        const el = this.sectionTargets[this.opSelect.select.selectedIndex - 1];

        if (el) {
            const t = this.calculateScrollOffset(el, -100, "top");
            window.scrollTo({
                top: t,
                behavior: "smooth"
            });
        }
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/scrollto_controller.js